import {ellipsis} from 'polished';
import styled from 'styled-components';

import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';

interface RulePillDivProps {
  isOpen: boolean;
}

/*
 * Style.
 */

export const StyledActivityRulePillDiv = styled.div<RulePillDivProps>`
  padding: 0 4px 1px 3px;
  max-width: 250px;
  display: inline-block;

  background: ${(p) => (p.isOpen ? p.theme.greys.shade30 : p.theme.greys.shade10)};
  border: 1px solid ${(p) => p.theme.greys.shade60};
  border-radius: 100px;

  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.tiny};
  font-weight: ${fontWeights.semibold};

  ${ellipsis()};

  &:hover {
    background: ${(p) => p.theme.greys.shade30};
    color: ${(p) => p.theme.greys.shade70};
  }
`;

export const StyledActivityRulePillTooltipContentIcon = styled(Icon)`
  display: inline-block;
  vertical-align: middle;
  margin: 0 4px 0 0;
`;

export const StyledActivityRulePillLinkIcon = styled(Icon)`
  display: inline-block;
  margin-bottom: -3px;
`;

export const StyledActivityRulePillLearnMoreDiv = styled.div`
  height: 100%;

  & > ${StyledActivityRulePillLinkIcon} {
    color: ${(p) => p.theme.greys.shade60};
  }

  &:hover > ${StyledActivityRulePillLinkIcon} {
    color: ${(p) => p.theme.greys.shade70};
  }
`;
